import { QueryObserverBaseResult, useQuery } from "react-query";
import { queryKeys } from "../../query";
import api from "../../client";
import { InstitutionDetailResponseData } from "../../types/institution";

export const getData = async (
  id: string | undefined,
): Promise<InstitutionDetailResponseData> => {
  const { data } = await api.get(`/institutions/${id}`);

  return data;
};

export const useInstitution = (
  id: string | undefined,
): QueryObserverBaseResult<InstitutionDetailResponseData> => {
  const { data, ...props } = useQuery(
    queryKeys.institution(id),
    () => getData(id),
    { enabled: Boolean(id) },
  );
  return { data, ...props };
};
